import React, { useContext, useEffect, useState } from 'react';
import PageTitle from "../../Components/PageTitle";
import Select from 'react-select';
import axios from 'axios';
import { abstartOldUrl, currentDateAndTime, decodeData, formatMonthYear } from '../../Constants/constants';
import html2pdf from "html2pdf.js";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import { ConfigContext } from '../../Context/ConfigContext';
import { NoRecords } from '../../Components/Shimmer';
import { formatDate, SubmitButton } from '../../Components/InputElements';
import { useLocation } from 'react-router-dom';
import Swal from 'sweetalert2';


function PaySlips(props) {
    const { apiURL, apiHeaderFile, apiHeaderJSON,permissions,setPermissions } = useContext(ConfigContext);
    const locationParams = useLocation();
    const queryParams = new URLSearchParams(locationParams.search);
    const encodedData = queryParams.get("abs");
    const decodedData = encodedData ? decodeData(encodedData,permissions) : [];

    const [loading, setLoading] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [loadingRows, setLoadingRows] = useState(false);
    const [loadingDownload, setLoadingDownload] = useState(false);
    const [download, setDownload] = useState(false);
    const [loadingFilter, setLoadingFilter] = useState(false);
    const [selectedMonth, setSelectedMonth] = useState("");
    const [payslipData, setPayslipData] = useState([]);
    const [payslip, setPayslip] = useState(false);
    const [payslipType, setPayslipType] = useState(false);
    const [monthOptions, setMonthOptions] = useState([]);
    const [isChanged, setIsChanged] = useState(false);
    const limitOptions = [10, 25, 50, 100];
    const [rows, setRows] = useState([]);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [pagination, setPagination] = useState({
            next: false,
            prev: false,
            page: 1,
            limit: 10,
            total_records: 0,
            total_pages: 0,
            loadingList: false
        });
    const [filterOptions, setFilterOptions] = useState({
        location_options: [],
        department_options: [],
    });
    const [filter, setFilter] = useState({
            keyword: null,
            month: null,
            location_id: null,
            department_id: null,
            publishOrUnpublish: "1",
    });
    const publishStatusOptions = [
        {
            value: "1",
            label: "Published"
        },
        {
            value: "0",
            label: "Unpublished"
        },
    ];
    // function getList() {
    //     const headers = apiHeaderJSON;
    //     axios
    //         .get(`${apiURL}Home/GetPaySlipList`, {
    //             params: {
    //                 employeeCode: localStorage.getItem("employee_code_emp"),
    //                 year: selectedMonth,
    //             },
    //             headers,
    //         })
    //         .then((response) => {
    //             const { success, data } = response?.data?.data;
    //             console.log("getPayslip ==>", response);
    //             if (success === true) {
    //                 setRows(data);
    //             }else{
    //                 setRows([]);
    //             }
    //             setLoading(false);
    //             setLoadingFilter(false);
    //             setLoadingRows(false);
    //         })
    //         .catch((error)=>{
    //             console.error(error);
    //             setLoading(false);
    //             setLoadingFilter(false);
    //             setLoadingRows(false);
    //         });
    // }
    // function getOldList() {
    //     axios.get(`${abstartOldUrl}pages/api/v1/payslip/list`,{
    //         params:{
    //             token: "asdf",
    //             emp_code: localStorage.getItem("employee_code_emp"),
    //             salary_month_year: selectedMonth,
    //         }
    //     })
    //     .then((response)=>{
    //         const data= response?.data;
    //         // console.log("pages/api/v1/payslip/list", data);
    //         const options= data?.data?.map((val)=>{
    //             return {value: val?.salary_month_year, label: val?.salary_month_year}
    //         });
    //         // console.log(options);
    //         // console.log(data?.data);
    //         setAllMonthsData(options);
    //         setRows(data?.data);
    //         setLoading(false);
    //         setLoadingRows(false);
    //         setLoadingFilter(false);
    //     })
    //     .catch((error)=>{
    //         setRows([]);
    //         console.error(error);
    //         setLoading(false);
    //         setLoadingRows(false);
    //         setLoadingFilter(false);
    //     })
    // }
    // get payslip months
    const getList = () => {
        const headers = apiHeaderJSON;
        // console.log("filter?.month", filter?.month);
        console.log(" pagination",  pagination );
        axios
            .get(`${apiURL}Payrolls/GetEmployeesListForPaySlip`, {
                params: {
                    limit: pagination?.limit || 10,
                    page: pagination?.page || 1,
                    keyword: filter?.keyword,
                    monthYear: filter?.month,
                    location_id: filter?.location_id,
                    department_id: filter?.department_id,
                    publish_status: filter?.publishOrUnpublish,
                },
                headers,
            })
            .then((response) => {
                var data = response?.data?.data;
                if (data?.success === true) {
                    // console.log(data);
                    setPagination({
                        next: data?.next,
                        prev: data?.prev,
                        page: data?.page || pagination?.page,
                        limit: data?.limit || pagination?.limit,
                        total_records: data?.total_records,
                        total_pages: data?.total_pages,
                        loadingList: false,
                    });
                    console.log("data?.data",data?.data);
                    setRows(data?.data);

                } else {
                    if(data?.message === "Month Year is required."){
                        setRows([]);
                    }
                    setPagination({ ...pagination, loadingList: false });
                }
                setLoading(false);
                setLoadingFilter(false);
            })
            .catch((error)=>{
                setLoading(false);
                setLoadingFilter(false);

            });
    };
    const getEmploymentMasterList = () => {
        const headers = apiHeaderJSON;
        axios
          .get(`${apiURL}Masters/GetEmploymentMasterList`, { headers })
          .then((response) => {
            let data = response.data;
            if (response.data.success === true) {
                data= data?.data;
              setFilterOptions({
                ...filterOptions,
                location_options: data.location_list.map((row) => ({
                  value: row.location_id,
                  label: row.location_title,
                })),
                department_options: data?.department_list.map((row) => ({
                    value: row.department_id,
                    label: row.department_title,
                  })),
              });  
            }
          });
      };
    function getPayslipByMonth() {
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Payrolls/GetSalaryRegisterMonthYearFilterData`,
            {
                params: {
                    date: currentDateAndTime()
                }
                , headers
            }).then(async (response) => {
                const { success, filterData } = response.data;
                // console.log("getPayslipByMonth ==>", response);
                if (success === true) {
                    if(Array.isArray(filterData) && filterData.length>0){
                        setFilter({
                            ...filter,
                            month: filterData[0]?.value
                        })
                        setIsChanged(true);
                        setMonthOptions(filterData);
                    }
                }
                setLoading(false);
                setLoadingFilter(false);
            }).catch((error) => {
                setLoading(false);
                setLoadingFilter(false);
                console.log('getPayslipByMonth => ERROR: ', error);
            });
    }

    useEffect(() => {
        // getPayslip();
        
        // if(payslipType){
        //     getOldList();
        // }else{
            setLoading(true);   
            // getList();
            getEmploymentMasterList();
        // }
        getPayslipByMonth();
    }, []);

    useEffect(() => {
        if(isChanged){
            // if(payslipType){
            //     console.log("1",isChanged);
            //     getOldList();
            // }else{
                console.log("2",isChanged);
                getList();
            // }
            setIsChanged(false);
        }
    }, [isChanged]);
    const handleSelectAll = (e) => {
        if (e.target.checked) {
            setSelectedRows(rows.map((row) => {
                return { employee_id: row?.employee_id, employee_name: row?.employee_name, employee_code: row?.employee_code }
            }));
        } else {
            setSelectedRows([]);
        }
    };
    const handleCheckboxChange = (employeeData) => {
        const isSelected = selectedRows.some(row => row.employee_id === employeeData?.employee_id);
        if (isSelected) {
            setSelectedRows(selectedRows.filter(row => row.employee_id !== employeeData?.employee_id));
        } else {
            setSelectedRows([...selectedRows, {
                employee_id: employeeData?.employee_id,
                employee_name: employeeData?.employee_name,
                employee_code: employeeData?.employee_code
            }]);
        }
    };
    // download payslip pdf function
    // const payslipFilter = () => {
    //     try {
    //         setLoadingFilter(true);
    //         let temp = allMonthsData?.filter((val) => {
    //             console.log(val?.salary_month_year, selectedMonth)
    //             if (val?.salary_month_year === selectedMonth) {
    //                 return val;
    //             }
    //         });
    //         console.log("====>>>>temp", temp);
    //         setMonthOptions(temp);
    //         setLoadingFilter(false)
    //     } catch (error) {
    //         setLoadingFilter(false);
    //     }
    // }

    // const handleChange = (name, value) => {
    //     setFilter({ ...filter, [name]: value });
    // }
    const handleInputChange = (e) => {
        setFilter({
            ...filter,
            [e.target.name]: e.target.value,
        });
        if (!e.target.value) {
            setIsChanged(true);
        }
    };
    const handleInputSearch = (e) => {
        getList();
    }
    function handleClearAll() {
        setSelectedMonth("");
        setFilter({
            ...filter,
            month: Array.isArray(monthOptions) && monthOptions?.length>0 && monthOptions[0]?.value,
            location_id: null,
            department_id: null,
            publishOrUnpublish:"1",
        })
        setIsChanged(true);
    }
    // const downloadButton = async (emp_code, salary_month, salary_year) => {
    //     setLoadingDownload(emp_code);
    //     try {
    //         const response = await fetch(`${abstartOldUrl}pages/api/v1/payslip/download?token=654&emp_code=${localStorage.getItem("employee_code_emp")}&who_is=employee&salary_month=${salary_month}&salary_year=${salary_year}`);
    //         if (!response.ok) {
    //             throw new Error('Network response was not ok');
    //         }
    //         const blob = await response.blob();
    //         const url = window.URL.createObjectURL(blob);
    //         const a = document.createElement('a');
    //         a.href = url;
    //         a.download = `${emp_code.replace(/ /g, "_")}_${salary_month}-${salary_year}_${new Date().toISOString().split("T")[0]}.pdf`;
    //         document.body.appendChild(a);
    //         a.click();
    //         document.bodyNaNpxoveChild(a);
    //         window.URL.revokeObjectURL(url); // Cleanup the URL object
    //         setLoadingDownload(false);
    //         setDownload(false);
    //     } catch (error) {
    //         console.error('There was a problem with the download:', error);
    //         setLoadingDownload(false);
    //         setDownload(false);
    //     }
    // }

    // const [payslipLeaveData, setPayslipLeaveData] = useState();
    // const [payslipEarning, setPayslipEarning] = useState();
    // const [payslipDeduction, setPayslipDeduction] = useState();
    // const [response, setResponse] = useState();

    // const downloadButton = (month, row) => {
    //     let payslip;
    //     let payslipLeaveData;
    //     let payslipEarning;
    //     let payslipDeduction;
    //     const headers = apiHeaderJSON;
    //     axios.get(`${apiURL}Home/GetPaySlip`, {
    //             params: {
    //                 month: month,
    //                 employees: selectedRows?.length>0? selectedRows : [{
    //                     employee_id: row?.employee_id,
    //                     employee_name: row?.employee_name,
    //                     employee_code: row?.employee_code}],
    //             },
    //             headers,
    //         })
    //         .then((response) => {
    //             const { success, employee_data, earning_data, deduction_data, leave_data } = response.data;
    //             // console.log("getPayslip ==>", response?.data);
    //             if (success === true) {
    //                 downloadPayslips(payslipData);
    //                 payslip = employee_data[0];
    //                 payslipLeaveData = leave_data;
    //                 payslipEarning = earning_data;
    //                 payslipDeduction = deduction_data;
    //                 const maxRows = Math.max(payslipEarning.length, payslipDeduction.length);
    //                 const earningRows = payslipEarning.length;
    //                 const deductionRows = payslipDeduction.length;

    //                 // Add empty rows to the shorter table
    //                 const emptyRowsEarning = new Array(maxRows - earningRows).fill({ salary_head_name_for_payslip: '', company_salary_head_value: '' });
    //                 const emptyRowsDeduction = new Array(maxRows - deductionRows).fill({ salary_head_name_for_payslip: '', company_salary_head_value: '' });

    //                 payslipEarning = payslipEarning.concat(emptyRowsEarning);
    //                 payslipDeduction = payslipDeduction.concat(emptyRowsDeduction);
    //                 setPayslip(employee_data[0]);
    //                 // setPayslipLeaveData(leave_data);
    //                 // setPayslipEarning(earning_data);
    //                 // setPayslipDeduction(deduction_data);
    //                 // setResponse(response.data);
    //                 // display: flex; justify-content: start; align-items: center; gap:1.2rem;
    //                 // display: grid; grid-template-columns: 1fr 4fr; justify-content: center; align-items: center;
    //                 //  style="display: flex; justify-content: center; flex-direction:column; align-items: start;"
    //                 const payslipContent = `
    //                     <div style="font-family: Arial, sans-serif; max-width: 1900px; padding: 5px; line-height: 1.4;">
    //                     <div style="display: grid; grid-template-columns: 1fr 4fr; justify-content: center; align-items: center; margin-bottom: 7px;">
    //                         <div style="min-width=50px; max-width=200px; width:100%;" >
    //                             ${payslip?.company_name ? `<img style="max-width: 150px; width: 100%;" src="/img/abstart-logo.png" alt="Company Logo"/>` :
    //                         `<div style="display: flex; justify-content: center; align-items: center; background-color: #f2f2f2; width: 50px; height: 50px; border-radius: 10px;">
    //                                 <img style="max-width: 150px; width: 100%;" src="/img/placeholder-logo.png" alt="Company Logo"/>
    //                             </div>`}
    //                         </div>
    //                         <div style="display: flex; justify-content: center; flex-direction:column; align-items: center;">
    //                             <h4 style="text-align: center; color: rgb(16 92 255); font-size: 1.2rem; margin:0px">${payslip?.company_name}</h4>
    //                             <p style="font-size: 0.6rem; text-align: center; color: #555; margin-bottom: 0px;"><strong>${payslip?.registered_office_address}</strong></p>
    //                         </div>
    //                     </div>
    //                     <div style="display: grid; grid-template-columns: 1fr 1fr; margin-bottom: 20px;">

    //                         <div style="border-top:1px solid #ddd; width:100%; margin-bottom:0.3rem;"></div>
    //                         <div style="border-top:1px solid #ddd; width:100%; margin-bottom:0.3rem;"></div>

    //                         <div style="display: grid; grid-template-columns: 1fr 1fr; padding: 0 5px; ">
    //                         <strong style="font-size: 0.62rem; margin-bottom:0.3rem;">Payslip for the month:</strong>
    //                         <p style="font-size: 0.62rem; margin-bottom:0.3rem;">${response?.data?.month_year}</p>
    //                         </div>
    //                         <div style="display: grid; grid-template-columns: 1fr 1fr; padding: 0 5px; ">
    //                         <strong style="font-size: 0.62rem; margin-bottom:0.3rem;">Designation:</strong>
    //                         <p style="font-size: 0.62rem; margin-bottom:0.3rem;">${payslip?.designation_title}</p>
    //                         </div>

    //                         <div style="border-top:1px solid #ddd; width:100%; margin-bottom:0.3rem;"></div>
    //                         <div style="border-top:1px solid #ddd; width:100%; margin-bottom:0.3rem;"></div>

    //                         <div style="display: grid; grid-template-columns: 1fr 1fr; padding: 0 5px; ">
    //                         <strong style="font-size: 0.62rem; margin-bottom:0.3rem;">Emp Code:</strong>
    //                         <p style="font-size: 0.62rem; margin-bottom:0.3rem;">${payslip?.employee_code}</p>
    //                         </div>
    //                         <div style="display: grid; grid-template-columns: 1fr 1fr; padding: 0 5px; ">
    //                         <strong style="font-size: 0.62rem; margin-bottom:0.3rem;">Location:</strong>
    //                         <p style="font-size: 0.62rem; margin-bottom:0.3rem;">${payslip?.location_title}</p>
    //                         </div>

    //                         <div style="border-top:1px solid #ddd; width:100%; margin-bottom:0.3rem;"></div>
    //                         <div style="border-top:1px solid #ddd; width:100%; margin-bottom:0.3rem;"></div>

    //                         <div style="display: grid; grid-template-columns: 1fr 1fr; padding: 0 5px; ">
    //                         <strong style="font-size: 0.62rem; margin-bottom:0.3rem;">Employee Name:</strong>
    //                         <p style="color: #1d9704; font-size: 0.62rem; margin-bottom:0.3rem;">${payslip?.employee_name}</p>
    //                         </div>
    //                         <div style="display: grid; grid-template-columns: 1fr 1fr; padding: 0 5px; ">
    //                         <strong style="font-size: 0.62rem; margin-bottom:0.3rem;">Department:</strong>
    //                         <p style="color: #1d9704; font-size: 0.62rem; margin-bottom:0.3rem;">${payslip?.department_title}</p>
    //                         </div>

    //                         <div style="border-top:1px solid #ddd; width:100%; margin-bottom:0.3rem;"></div>
    //                         <div style="border-top:1px solid #ddd; width:100%; margin-bottom:0.3rem;"></div>

    //                         <div style="display: grid; grid-template-columns: 1fr 1fr; padding: 0 5px; ">
    //                         <strong style="font-size: 0.62rem; margin-bottom:0.3rem;">Joining Date:</strong>
    //                         <p style="font-size: 0.62rem; margin-bottom:0.3rem;">${payslip?.employee_joining_date}</p>
    //                         </div>
    //                         <div style="display: grid; grid-template-columns: 1fr 1fr; padding: 0 5px; ">
    //                         <strong style="font-size: 0.62rem; margin-bottom:0.3rem;">ESIC No.:</strong>
    //                         <p style="color: #1d9704; font-size: 0.62rem;"></p>
    //                         </div>

    //                         <div style="border-top:1px solid #ddd; width:100%; margin-bottom:0.3rem;"></div>
    //                         <div style="border-top:1px solid #ddd; width:100%; margin-bottom:0.3rem;"></div>

    //                         <div style="display: grid; grid-template-columns: 1fr 1fr; padding: 0 5px; ">
    //                         <strong style="font-size: 0.62rem; margin-bottom:0.3rem;">UAN No.:</strong>
    //                         <p style="color: #1d9704; font-size: 0.62rem; margin-bottom:0.3rem;"></p>
    //                         </div>
    //                     </div>
    //                     <div style="border-top:1px solid #ddd; width:100%; margin-bottom:0.3rem;"></div>
    //                     <div style="display: grid; grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr; margin-bottom: 5px;">
    //                         <strong style="font-size: 0.62rem; margin-bottom:0.3rem; padding: 0 5px;">Days Paid:</strong>
    //                         <p style="font-size: 0.62rem; margin-bottom:0.3rem; padding: 0 5px;">${response?.data?.payable_days}</p>
    //                         <strong style="font-size: 0.62rem; margin-bottom:0.3rem; padding: 0 5px;">Days Present:</strong>
    //                         <p style="color: #1d9704; font-size: 0.62rem; margin-bottom:0.3rem; padding: 0 5px;">${response?.data?.present_days}</p>
    //                         <strong style="font-size: 0.62rem; margin-bottom:0.3rem; padding: 0 5px;">LWP/Absent:</strong>
    //                         <p style="font-size: 0.62rem; margin-bottom:0.3rem; padding: 0 5px;">${response?.data?.LOP_days}</p>
    //                     </div>
    //                     <div style="display: grid; grid-template-columns: 1fr 1fr 1fr 1fr; margin: 5px 0;">
    //                         ${payslipLeaveData?.map((leave, index) => `
    //                             <div>
    //                                 <div style="border-top:1px solid #ddd; width:100%; margin-bottom:0.3rem;"></div>
    //                                 <div style="display: grid; grid-template-columns: 1fr 1fr; padding: 0 5px">
    //                                     <strong style="font-size: 0.62rem; margin-bottom:0.3rem;">${leave.key}:</strong>
    //                                     <p style="color: #1d9704; font-size: 0.62rem; margin-bottom:0.3rem;">${leave.value}</p>
    //                                 </div>
    //                             </div>
    //                         `).join('')}
    //                     </div>
    //                     <div style="display: grid; grid-template-columns: 1fr 1fr; margin-top:2rem;">
    //                         <div>
    //                         <table style="width: 100%; border-collapse: collapse; font-size: 0.62rem;">
    //                             <thead>
    //                             <tr style="background-color: #f2f2f2;">
    //                                 <th style="border: 1px solid #ddd; padding: 6px;">Earnings</th>
    //                                 <th style="border: 1px solid #ddd; padding: 6px;">Amount</th>
    //                             </tr>
    //                             </thead>
    //                             <tbody>
    //                             ${payslipEarning?.map(earning => `
    //                                 <tr style="height: 1.75rem">
    //                                 <td style="border: 1px solid #ddd; padding: 6px;">${earning.salary_head_name_for_payslip}</td>
    //                                 <td style="border: 1px solid #ddd; padding: 6px;">${earning.company_salary_head_value}</td>
    //                                 </tr>`).join('')}
    //                             <tr style="height: 1.75rem">
    //                                 <td style="border: 1px solid #ddd; padding: 6px;"><strong>Total Amount</strong></td>
    //                                 <td style="border: 1px solid #ddd; padding: 6px;"><strong>${response?.data?.total_earned_gross}</strong></td>
    //                             </tr>
    //                             </tbody>
    //                         </table>
    //                         </div>

    //                         <div>
    //                         <table style="width: 100%; border-collapse: collapse; font-size: 0.62rem;">
    //                             <thead>
    //                             <tr style="background-color: #f2f2f2;">
    //                                 <th style="border: 1px solid #ddd; padding: 6px;">Deductions & Recoveries</th>
    //                                 <th style="border: 1px solid #ddd; padding: 6px;">Amount</th>
    //                             </tr>
    //                             </thead>
    //                             <tbody>
    //                             ${payslipDeduction?.map(deduction => `
    //                                 <tr style="height: 1.75rem">
    //                                 <td style="border: 1px solid #ddd; padding: 6px;">${deduction.salary_head_name_for_payslip}</td>
    //                                 <td style="border: 1px solid #ddd; padding: 6px;">${deduction.company_salary_head_value}</td>
    //                                 </tr>`).join('')}
    //                             <tr style="height: 1.75rem">
    //                                 <td style="border: 1px solid #ddd; padding: 6px;"><strong>Total Amount</strong></td>
    //                                 <td style="border: 1px solid #ddd; padding: 6px;"><strong>${response?.data?.total_deduction}</strong></td>
    //                             </tr>
    //                             </tbody>
    //                         </table>
    //                         </div>
    //                     </div>

    //                     <table style="width: 100%; border-collapse: collapse; margin-top: 1rem; font-size: 0.63rem;">
    //                         <tbody>
    //                         <tr>
    //                             <td style="border: 1px solid #ddd;">
    //                             <p style=" margin-bottom: 0;" class="px-3 py-1"><strong>Net Pay: ${response?.data?.total_net_pay}</strong></p>
    //                             </td>
    //                         </tr>
    //                         <tr>
    //                             <td style="border: 1px solid #ddd;">
    //                             <p style=" margin-bottom: 0;" class="px-3 py-1"><strong>In Words: ${response?.data?.total_net_pay_in_word}</strong></p>
    //                             </td>
    //                         </tr>
    //                         <tr>
    //                             <td style="border: 1px solid #ddd;">
    //                             <p style="color: #777; margin-bottom: 0; font-size: 0.6rem " class="px-3 py-1">This payslip is computer generated and does not require a signature.</p>
    //                             </td>
    //                         </tr>
    //                         </tbody>
    //                     </table>
    //                     </div>
    //                 `;


    //                 const options = {
    //                     margin: 0.5,
    //                     filename: `${localStorage.getItem("employee_code_emp")} ${payslip?.employee_name} ${response?.data?.month_year}.pdf`,
    //                     image: { type: 'jpeg', quality: 0.98 },
    //                     html2canvas: { scale: 2 },
    //                     jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' }
    //                 };

    //                 // Generate PDF
    //                 html2pdf().from(payslipContent).set(options).save();
    //             }
    //             console.log("loadingDownload 3");
    //             setLoadingDownload(false);
    //             setDownload(false);
    //         }).catch((error) => {
    //             console.log("loadingDownload 4");
    //             setLoadingDownload(false);
    //             setDownload(false);
    //         });
    // };
    // const downloadButton = (row) => {
    //     const headers = apiHeaderJSON;
    //     axios.get(`${apiURL}Payrolls/GetPaySlip`, {
    //             params: {
    //                 month: filter?.month,
    //                 employees: selectedRows?.length>0? selectedRows : [{
    //                     employee_id: row?.employee_id,
    //                     employee_name: row?.employee_name,
    //                     employee_code: row?.employee_code}],
    //             },
    //             headers,
    //         })
    //         .then((response) => {
    //             const { success, payslipData } = response.data;
    //             console.log("Payrolls/GetPaySlip => payslipData ==>", payslipData);
    //             if (success === true) {
    //                 downloadPayslips(payslipData); 
                    
                    
    //             }
    //             // console.log("loadingDownload 3");
    //             setLoadingDownload(false);
    //             setLoadingFilter(false);
    //             setDownload(false);
    //         }).catch((error) => {
    //             console.log("loadingDownload 4");
    //             setLoadingDownload(false);
    //             setLoadingFilter(false);
    //             setDownload(false);
    //         });
    // };
    
    const downloadButton = async (row) => {
        const headers = apiHeaderJSON;
        setUploadProgress(0);
        setLoadingRows("1");
        const formData={
            month: filter?.month,
            employees: selectedRows?.length > 0 ? selectedRows : [{
                employee_id: row?.employee_id,
                employee_name: row?.employee_name,
                employee_code: row?.employee_code
            }],
        }
        console.log("Payrolls/GetPaySlip formData",formData)
        try {
            const response = await axios.post(`${apiURL}Payrolls/GetPaySlip`,formData,{headers,});
    
            const { success, payslipData } = response.data;
            console.log("Payrolls/GetPaySlip => payslipData ==>", payslipData);    
            if (success === true) {
                
                await downloadPayslips(payslipData);
            }
            else{
                setLoadingRows(false);
                setLoadingDownload(false);
                setLoadingFilter(false);
                setDownload(false);
                setUploadProgress(0);
                Swal.fire({
                    title: `<strong>${response.data?.success ? 'Success' : 'Failed'}</strong>`,
                    text: response.data.message,
                    icon: response.data?.success ? 'success' : 'error',
                    showConfirmButton: true,
                    allowOutsideClick: false,
                });

            }
            // setLoadingDownload(false);
            // setLoadingFilter(false);
            // setDownload(false);
        } catch (error) {
            console.error("Error fetching payslips:", error);
            Swal.fire({
                title: `<strong>Failed</strong>`,
                text: "Opps...! Something went wrong",
                icon: 'error',
                showConfirmButton: true,
                allowOutsideClick: false,
            });
            setLoadingRows(false);
            setLoadingDownload(false);
            setLoadingFilter(false);
            setDownload(false);
            setUploadProgress(0);
        }
    };
    
    const downloadPayslips = async (payslipData) => {
        console.log("payslipData?.length = ", payslipData?.length);
        if (payslipData.length === 0) return;
    
        if (payslipData.length === 1) {
            
            const payslip = payslipData[0]?.employee_data[0];
                const payslipLeaveData = payslipData[0]?.leave_data;
                let payslipEarning = payslipData[0]?.earning_data;
                let payslipDeduction = payslipData[0]?.deduction_data;
                const maxRows = Math.max(payslipEarning.length, payslipDeduction.length);
                const earningRows = payslipEarning.length;
                const deductionRows = payslipDeduction.length;
    
                // Add empty rows to the shorter table
                const emptyRowsEarning = new Array(maxRows - earningRows).fill({ salary_head_name_for_payslip: '', company_salary_head_value: '' });
                const emptyRowsDeduction = new Array(maxRows - deductionRows).fill({ salary_head_name_for_payslip: '', company_salary_head_value: '' });
    
                payslipEarning = payslipEarning.concat(emptyRowsEarning);
                payslipDeduction = payslipDeduction.concat(emptyRowsDeduction);
            await generatePDF(payslip, payslipLeaveData, payslipEarning, payslipDeduction, payslipData[0], false);
        } else {
            setLoadingRows("2");
            const zip = new JSZip();
            const totalLength= payslipData.length;
            for (let i = 0; i < payslipData.length; i++) {
                const payslip = payslipData[i]?.employee_data[0];
                const payslipLeaveData = payslipData[i]?.leave_data;
                let payslipEarning = payslipData[i]?.earning_data;
                let payslipDeduction = payslipData[i]?.deduction_data;
                const maxRows = Math.max(payslipEarning.length, payslipDeduction.length);
                const earningRows = payslipEarning.length;
                const deductionRows = payslipDeduction.length;
    
                // Add empty rows to the shorter table
                const emptyRowsEarning = new Array(maxRows - earningRows).fill({ salary_head_name_for_payslip: '', company_salary_head_value: '' });
                const emptyRowsDeduction = new Array(maxRows - deductionRows).fill({ salary_head_name_for_payslip: '', company_salary_head_value: '' });
    
                payslipEarning = payslipEarning.concat(emptyRowsEarning);
                payslipDeduction = payslipDeduction.concat(emptyRowsDeduction);
    
                console.log(`Generating PDF for Employee ${payslip?.employee_code}`);
    
                // Wait for each PDF to be generated before moving to the next
                const pdfBlob = await generatePDF(payslip, payslipLeaveData, payslipEarning, payslipDeduction, payslipData[i], true);
                zip.file(`Payslip_${payslip?.employee_code}_${payslip?.employee_name}.pdf`, pdfBlob);
                setUploadProgress(Math.round(((i + 1) / totalLength) * 100));
                // console.log("((i + 1) / totalLength) * 100",Math.round(((i + 1) / totalLength) * 100));
            }
    
            // Generate ZIP file
            zip.generateAsync({ type: "blob" }).then((content) => {
                saveAs(content, "Payslips.zip");
                // setLoadingDownload(false);
                // setLoadingFilter(false);
                // setDownload(false);
            });
        }
    };
    
      
      const generatePDF = (payslip,payslipLeaveData,payslipEarning,payslipDeduction,payslipData, returnBlob = false) => {
        return new Promise((resolve) => {
          // Create a hidden div to render the payslip
          const payslipElement = document.createElement("div");
          payslipElement.innerHTML =  `
          <div style="font-family: Arial, sans-serif; max-width: 1900px; padding: 5px; line-height: 1.4;">
          <div style="display: grid; grid-template-columns: 1fr 4fr; justify-content: center; align-items: center; margin-bottom: 7px;">
                
            ${!['3','5','24','27', '28'].includes(apiHeaderJSON["x-company-id"]) ? 
                `
                <div style="min-width=50px; max-width=200px; width:100%;" >
                  ${payslip?.company_name ? `<img style="max-width: 150px; width: 100%;" src="/img/tcoLogo.png" alt="Company Logo"/>` :
                 `<div style="display: flex; justify-content: center; align-items: center; background-color: #f2f2f2; width: 50px; height: 50px; border-radius: 10px;">
                      <img style="max-width: 150px; width: 100%;" src="/img/placeholder-logo.png" alt="Company Logo"/>
                  </div>`}
                </div>
                
                `
                :
                `
                <div style="min-width=50px; max-width=200px; width:100%;" >
                  ${payslip?.company_name ? `<img style="max-width: 150px; width: 100%;" src="/img/abstart-logo.png" alt="Company Logo"/>` :
                 `<div style="display: flex; justify-content: center; align-items: center; background-color: #f2f2f2; width: 50px; height: 50px; border-radius: 10px;">
                      <img style="max-width: 150px; width: 100%;" src="/img/placeholder-logo.png" alt="Company Logo"/>
                </div>`}
              </div>
                `
            }
              <div style="display: flex; justify-content: center; flex-direction:column; align-items: center;">
                  <h4 style="text-align: center; color: rgb(16 92 255); font-size: 1.2rem; margin:0px">${payslip?.company_name || ""}</h4>
                  <p style="font-size: 0.6rem; text-align: center; color: #555; margin-bottom: 0px;"><strong>${payslip?.registered_office_address || ""}</strong></p>
              </div>
          </div>
          <div style="display: grid; grid-template-columns: 1fr 1fr; margin-bottom: 20px;">

              <div style="border-top:1px solid #ddd; width:100%; margin-bottom:0.3rem;"></div>
              <div style="border-top:1px solid #ddd; width:100%; margin-bottom:0.3rem;"></div>

              <div style="display: grid; grid-template-columns: 1fr 1fr; padding: 0 5px; ">
              <strong style="font-size: 0.62rem; margin-bottom:0.3rem;">Payslip for the month</strong>
              <p style="font-size: 0.62rem; margin-bottom:0.3rem;">${payslipData?.month_year ? formatMonthYear(payslipData?.month_year) : ""}</p>
              </div>
              <div style="display: grid; grid-template-columns: 1fr 1fr; padding: 0 5px; ">
              <strong style="font-size: 0.62rem; margin-bottom:0.3rem;">Designation</strong>
              <p style="font-size: 0.62rem; margin-bottom:0.3rem;">${payslip?.designation_title || ""}</p>
              </div>

              <div style="border-top:1px solid #ddd; width:100%; margin-bottom:0.3rem;"></div>
              <div style="border-top:1px solid #ddd; width:100%; margin-bottom:0.3rem;"></div>

              <div style="display: grid; grid-template-columns: 1fr 1fr; padding: 0 5px; ">
              <strong style="font-size: 0.62rem; margin-bottom:0.3rem;">Emp Code</strong>
              <p style="font-size: 0.62rem; margin-bottom:0.3rem;">${payslip?.employee_code || ""}</p>
              </div>
              <div style="display: grid; grid-template-columns: 1fr 1fr; padding: 0 5px; ">
              <strong style="font-size: 0.62rem; margin-bottom:0.3rem;">Location</strong>
              <p style="font-size: 0.62rem; margin-bottom:0.3rem;">${payslip?.location_title || ""}</p>
              </div>

              <div style="border-top:1px solid #ddd; width:100%; margin-bottom:0.3rem;"></div>
              <div style="border-top:1px solid #ddd; width:100%; margin-bottom:0.3rem;"></div>

              <div style="display: grid; grid-template-columns: 1fr 1fr; padding: 0 5px; ">
              <strong style="font-size: 0.62rem; margin-bottom:0.3rem;">Employee Name</strong>
              <p style="color: #1d9704; font-size: 0.62rem; margin-bottom:0.3rem;">${payslip?.employee_name || ""}</p>
              </div>
              <div style="display: grid; grid-template-columns: 1fr 1fr; padding: 0 5px; ">
              <strong style="font-size: 0.62rem; margin-bottom:0.3rem;">Department</strong>
              <p style="color: #1d9704; font-size: 0.62rem; margin-bottom:0.3rem;">${payslip?.department_title || ""}</p>
              </div>

              <div style="border-top:1px solid #ddd; width:100%; margin-bottom:0.3rem;"></div>
              <div style="border-top:1px solid #ddd; width:100%; margin-bottom:0.3rem;"></div>

              <div style="display: grid; grid-template-columns: 1fr 1fr; padding: 0 5px; ">
              <strong style="font-size: 0.62rem; margin-bottom:0.3rem;">Joining Date</strong>
              <p style="font-size: 0.62rem; margin-bottom:0.3rem;">${payslip?.employee_joining_date? formatDate(payslip?.employee_joining_date) : ""}</p>
              </div>
              <div style="display: grid; grid-template-columns: 1fr 1fr; padding: 0 5px; ">
              <strong style="font-size: 0.62rem; margin-bottom:0.3rem;">ESIC No</strong>
              <p style="color: #1d9704; font-size: 0.62rem;">${payslip?.esic_number || ""}</p>
              </div>

              <div style="border-top:1px solid #ddd; width:100%; margin-bottom:0.3rem;"></div>
              <div style="border-top:1px solid #ddd; width:100%; margin-bottom:0.3rem;"></div>

              <div style="display: grid; grid-template-columns: 1fr 1fr; padding: 0 5px; ">
              <strong style="font-size: 0.62rem; margin-bottom:0.3rem;">Group Join Date</strong>
              <p style="color: #1d9704; font-size: 0.62rem; margin-bottom:0.3rem;"></p>
              </div>
              <div style="display: grid; grid-template-columns: 1fr 1fr; padding: 0 5px; ">
              <strong style="font-size: 0.62rem; margin-bottom:0.3rem;">UAN No</strong>
              <p style=" font-size: 0.62rem; margin-bottom:0.3rem;">${payslip?.uan_number || ""}</p>
              </div>

              <div style="border-top:1px solid #ddd; width:100%; margin-bottom:0.3rem;"></div>
              <div style="border-top:1px solid #ddd; width:100%; margin-bottom:0.3rem;"></div>

              <div style="display: grid; grid-template-columns: 1fr 1fr; padding: 0 5px; ">
              <strong style="font-size: 0.62rem; margin-bottom:0.3rem;">Acc No</strong>
              <p style="font-size: 0.62rem; margin-bottom:0.3rem;">${payslip?.employee_bank_account_number || ""}</p>
              </div>
              <div style="display: grid; grid-template-columns: 1fr 1fr; padding: 0 5px; ">
              <strong style="font-size: 0.62rem; margin-bottom:0.3rem;">IFSC</strong>
              <p style="font-size: 0.62rem; margin-bottom:0.3rem;">${payslip?.employee_bank_Ifsc || ""}</p>
              </div>

          </div>
           ${ 
                (apiHeaderJSON["x-company-id"] == 26 || apiHeaderJSON["x-company-id"] == 28) ? 
                `
                <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; margin: 5px 0;">
                    <div>
                        <div style="border-top:1px solid #ddd; width:100%; margin-bottom:0.3rem;"></div>
                        <div style="display: grid; grid-template-columns: 1fr 1fr; padding: 0 5px">
                            <strong style="font-size: 0.62rem; margin-bottom:0.3rem;">Days Paid:</strong>
                            <p style=" font-size: 0.62rem; margin-bottom:0.3rem;">${payslipData?.present_days}</p>
                        </div>
                    </div>
                     
                </div>
                `
                :
                `
                <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; margin: 5px 0;">
                    <div>
                        <div style="border-top:1px solid #ddd; width:100%; margin-bottom:0.3rem;"></div>
                        <div style="display: grid; grid-template-columns: 1fr 1fr; padding: 0 5px">
                            <strong style="font-size: 0.62rem; margin-bottom:0.3rem;">Days Paid:</strong>
                            <p style=" font-size: 0.62rem; margin-bottom:0.3rem;">${payslipData?.payable_days}</p>
                        </div>
                    </div>
                    <div>
                        <div style="border-top:1px solid #ddd; width:100%; margin-bottom:0.3rem;"></div>
                        <div style="display: grid; grid-template-columns: 1fr 1fr; padding: 0 5px">
                        <strong style="font-size: 0.62rem; margin-bottom:0.3rem;">Days Present:</strong>
                        <p style="color: #1d9704; font-size: 0.62rem; margin-bottom:0.3rem;">${payslipData?.present_days}</p>
                        </div>
                    </div>
                    <div>
                        <div style="border-top:1px solid #ddd; width:100%; margin-bottom:0.3rem;"></div>
                        <div style="display: grid; grid-template-columns: 1fr 1fr; padding: 0 5px">
                            <strong style="font-size: 0.62rem; margin-bottom:0.3rem;">LWP/Absent:</strong>
                            <p style=" font-size: 0.62rem; margin-bottom:0.3rem;">${payslipData?.LOP_days}</p>
                        </div>
                    </div>
                </div>
                `
            }
            
          <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; margin: 5px 0;">
              ${payslipLeaveData?.map((leave) =>
                Object.entries(leave)
                    .map(([key, value]) => `
                        <div>
                            <div style="border-top:1px solid #ddd; width:100%; margin-bottom:0.3rem;"></div>
                            <div style="display: grid; grid-template-columns: 1fr 1fr; padding: 0 5px">
                                <strong style="font-size: 0.62rem; margin-bottom:0.3rem;">${key}:</strong>
                                <p style="color: #1d9704; font-size: 0.62rem; margin-bottom:0.3rem;">${value}</p>
                            </div>
                        </div>
                    `)
                    .join('')
            )
            .join('')}
          </div>
          <div style="display: grid; grid-template-columns: 1fr 1fr; margin-top:2rem;">
              <div>
              <table style="width: 100%; border-collapse: collapse; font-size: 0.62rem;">
                  <thead>
                  <tr style="background-color: #f2f2f2;">
                      <th style="border: 1px solid #ddd; padding: 6px;">Earnings</th>
                      <th style="border: 1px solid #ddd; padding: 6px;">Amount</th>
                  </tr>
                  </thead>
                  <tbody>
                  ${payslipEarning?.map(earning => `
                      <tr style="height: 1.75rem">
                      <td style="border: 1px solid #ddd; padding: 6px;">${earning.salary_head_name_for_payslip}</td>
                      <td style="border: 1px solid #ddd; padding: 6px;">${earning.company_salary_head_value}</td>
                      </tr>`).join('')}
                  <tr style="height: 1.75rem">
                      <td style="border: 1px solid #ddd; padding: 6px;"><strong>Total Amount</strong></td>
                      <td style="border: 1px solid #ddd; padding: 6px;"><strong>${payslipData?.total_earned_gross}</strong></td>
                  </tr>
                  </tbody>
              </table>
              </div>

              <div>
              <table style="width: 100%; border-collapse: collapse; font-size: 0.62rem;">
                  <thead>
                  <tr style="background-color: #f2f2f2;">
                      <th style="border: 1px solid #ddd; padding: 6px;">Deductions & Recoveries</th>
                      <th style="border: 1px solid #ddd; padding: 6px;">Amount</th>
                  </tr>
                  </thead>
                  <tbody>
                  ${payslipDeduction?.map(deduction => `
                      <tr style="height: 1.75rem">
                      <td style="border: 1px solid #ddd; padding: 6px;">${deduction.salary_head_name_for_payslip}</td>
                      <td style="border: 1px solid #ddd; padding: 6px;">${deduction.company_salary_head_value}</td>
                      </tr>`).join('')}
                  <tr style="height: 1.75rem">
                      <td style="border: 1px solid #ddd; padding: 6px;"><strong>Total Amount</strong></td>
                      <td style="border: 1px solid #ddd; padding: 6px;"><strong>${payslipData?.total_deduction}</strong></td>
                  </tr>
                  </tbody>
              </table>
              </div>
          </div>

          <table style="width: 100%; border-collapse: collapse; margin-top: 1rem; font-size: 0.63rem;">
              <tbody>
              <tr>
                  <td style="border: 1px solid #ddd;">
                  <p style=" margin-bottom: 0;" class="px-3 py-1"><strong>Net Pay: ${payslipData?.total_net_pay}</strong></p>
                  </td>
              </tr>
              <tr>
                  <td style="border: 1px solid #ddd;">
                  <p style=" margin-bottom: 0;" class="px-3 py-1"><strong>In Words: ${payslipData?.total_net_pay_in_word}</strong></p>
                  </td>
              </tr>
              <tr>
                  <td style="border: 1px solid #ddd;">
                  <p style="color: #777; margin-bottom: 0; font-size: 0.6rem " class="px-3 py-1">This payslip is computer generated and does not require a signature.</p>
                  </td>
              </tr>
              </tbody>
          </table>
          </div>
      `;
          document.body.appendChild(payslipElement);
      console.log("payslip ==~~~~",payslip);
      console.log("payslip.employee_code ==~~~~",payslip.employee_code);
          const options = {
            margin: 10,
            filename: `Payslip ${payslip.employee_code} ${payslip?.employee_name} ${payslipData?.month_year ? formatMonthYear(payslipData?.month_year) : ""}.pdf`,
            image: { type: "jpeg", quality: 0.98 },
            html2canvas: { scale: 2 },
            jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
          };
      
          html2pdf()
            .from(payslipElement)
            .set(options)
            .outputPdf("blob")
            .then((pdfBlob) => {
              document.body.removeChild(payslipElement); // Remove after conversion
              if (returnBlob) {
                resolve(pdfBlob);
                console.log("resolve(pdfBlob)");
              } else {
                console.log("Direct download for single payslip");
                html2pdf().from(payslipElement).set(options).save(); // Direct download for single payslip
                setLoadingDownload(false);
                setLoadingFilter(false);
                setDownload(false);
              }
            });
        });
      };
    // const downloadOldButton = async (emp_code, salary_month, salary_year) => {
    //         try {
    //             const response = await fetch(`${abstartOldUrl}pages/api/v1/payslip/download?token=654&emp_code=${localStorage.getItem("employee_code_emp")}&who_is=employee&salary_month=${salary_month}&salary_year=${salary_year}`);
    //             if (!response.ok) {
    //                 throw new Error('Network response was not ok');
    //             }
    //             console.log("response",response);
    //             const blob = await response.blob();
    //             const url = window.URL.createObjectURL(blob);
    //             const a = document.createElement('a');
    //             a.href = url;
    //             a.download = `${emp_code.replace(/ /g, "_")} ${salary_month}-${salary_year}.pdf`;
    //             document.body.appendChild(a);
    //             a.click();
    //             document.bodyNaNpxoveChild(a);
    //             setTimeout(() => {
    //                 document.body.removeChild(a);
    //                 window.URL.revokeObjectURL(url);
    //                 setLoadingDownload(false);
    //                 setDownload(false);
    //             }, 3000);
    //         } catch (error) {
    //             console.error('There was a problem with the download:', error);
    //             setLoadingDownload(false);
    //             setDownload(false);
    //         }
    //     }

    const downloadOldButton = (emp_code, salary_month, salary_year) => {
        axios.get(`${abstartOldUrl}pages/api/v1/payslip/download`, {
            params: {
                token: "654",
                emp_code: localStorage.getItem("employee_code_emp"),
                who_is: "employee",
                salary_month: salary_month,
                salary_year: salary_year
            },
            responseType: 'blob'
        })
        .then((response) => {
            console.log("response", response);
            const blob = new Blob([response.data], { type: response.headers['content-type'] });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `${emp_code.replace(/ /g, "_")} ${salary_month}-${salary_year}.pdf`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
            console.log("loadingDownload 1");
            setLoadingDownload(false);
            setDownload(false);
        })
        .catch((error) => {
            console.error('There was a problem with the download:', error);
            console.log("loadingDownload 2");
            setLoadingDownload(false);
            setDownload(false);
        });
    };
    
    useEffect(()=>{
        console.log("loadingDownload",loadingDownload)
    },[loadingDownload])

    const handlePrev = () => {
        if (pagination?.prev === true) {
            setPagination({
                ...pagination,
                page: pagination?.page - 1
            });
            setIsChanged(true);
        }
    }
    const handleNext = () => {
        if (pagination?.next === true) {
            setPagination({
                ...pagination,
                page: pagination?.page + 1
            });
            setIsChanged(true);
        }
    }
    const handleChanged = (e) => {
        setPagination({
            ...pagination,
            page: parseInt(e.target.value, 10)
        });
        setIsChanged(true);
    }
    const handleLimitChange = (e) => {
        setPagination(
            {
                ...pagination,
                limit: parseInt(e.target.value, 10),
                page: 1,
            }
        );
        setIsChanged(true);
    };


    return (
        <>
            {!loading ?
                <div class="main-content" >
                    <div class="page-content">
                        <div className="container-fluid">
                            <br />
                            <PageTitle title={`Payslip`} primary={`My Details`} />
                            <div className="card">
                                <div className="card-body">
                                    <div className="card-header">
                                        <div className="row">
                                            <div className='col-md-3'>
                                                <label htmlFor="keyword">Search By Name</label>
                                                <div className="input-group">
                                                    <input type="search" className="form-control" onChange={handleInputChange} name="keyword" value={filter?.keyword} aria-label="Recipient's username" aria-describedby="button-addon2" placeholder="Enter Name" />
                                                    <button className="btn btn-success" onClick={handleInputSearch} type="button" id="button-addon2"><i className="ri-search-line"></i></button>
                                                </div>
                                            </div>
                                            <div className='col-md-3 position-relative'>
                                                <div style={{ "zIndex": 10, "width": "90%" }} className=' position-absolute'>
                                                    <label htmlFor="Location" className="form-label" > Select Month </label>
                                                    <Select
                                                        options={monthOptions}
                                                        value={
                                                            filter?.month
                                                                ? monthOptions.find(option => option.value === filter?.month)
                                                                : null
                                                        }
                                                        onChange={(selectOption) => setFilter({ ...filter, month: selectOption?.value })}
                                                        placeholder={`Select Month`} />
                                                </div>
                                            </div>
                                            <div className='col-md-3 position-relative'>
                                                <div style={{ "zIndex": 10, "width": "90%" }} className=' position-absolute'>
                                                    <label htmlFor="Location" className="form-label" >Publish Status</label>
                                                    <Select
                                                        options={publishStatusOptions}
                                                        value={
                                                            filter?.publishOrUnpublish
                                                                ? publishStatusOptions.find(option => option.value == filter?.publishOrUnpublish)
                                                                : null
                                                        }
                                                        onChange={(selectOption) => {
                                                            setFilter({ ...filter, publishOrUnpublish: selectOption?.value });
                                                        }}
                                                        placeholder={`Select Status`} />
                                                </div>
                                            </div>
                                            <div className="col-md-3 position-relative">
                                                <div style={{ zIndex: 9, width: "90%" }}className=" position-absolute">
                                                    <div>
                                                    <label>Department</label>
                                                    </div>
                                                    <Select
                                                    options={filterOptions?.department_options}
                                                    value={
                                                        filter?.department_id
                                                        ? filterOptions?.department_options.find(
                                                            (option) =>
                                                                option.value === filter?.department_id
                                                            )
                                                        : null
                                                    }
                                                    onChange={(selectedOption) =>
                                                        setFilter({ ...filter, department_id: selectedOption?.value })
                                                    }
                                                    placeholder={`Select Designation`}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-3 mb-5 position-relative">
                                                <div style={{ zIndex: 8, width: "90%" }}className=" position-absolute">
                                                    <div>
                                                    <label>Location</label>
                                                    </div>
                                                    <Select
                                                    options={filterOptions?.location_options}
                                                    value={
                                                        filter?.location_id
                                                        ? filterOptions?.location_options.find(
                                                            (option) =>
                                                                option.value === filter?.location_id
                                                            )
                                                        : null
                                                    }
                                                    onChange={(selectedOption) =>
                                                        setFilter({ ...filter, location_id: selectedOption?.value })
                                                    }
                                                    placeholder={`Select Location`}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <div>
                                                            <label>Apply Filter</label>
                                                        </div>
                                                        <SubmitButton onClick={(e)=>{ 
                                                            setLoadingFilter("1");
                                                        //   if(payslipType){
                                                        //         setRows([]);
                                                        //         getOldList();
                                                        //     }else{
                                                                getList();
                                                            // } 
                                                        }}
                                                        disabled={!filter?.location_id && !filter?.month && !filter?.department_id} 
                                                        loading={loadingFilter==="1"}
                                                        loadingMessage='Loading' buttonName={'Filter'} icon={'ri-filter-3-fill'} 
                                                        type='info' iconSide='left' />

                                                    </div>
                                                    <div className="col-md-6">
                                                        <div>
                                                            <label className=' text-nowrap'>Clear Filter</label>
                                                        </div>
                                                            <SubmitButton onClick={(e)=>{ 
                                                                setLoadingFilter("2"); 
                                                                handleClearAll(); }}
                                                            disabled={!filter?.location_id && !filter?.month && !filter?.department_id} 
                                                            loading={loadingFilter==="2"}
                                                            loadingMessage='Loading' buttonName={'Clear'} icon={'ri-filter-3-fill'} 
                                                            type='secondary' iconSide='left' />
                                                    </div>
                                                </div>
                                            </div>
                                            { selectedRows?.length>0 && (
                                                <div className="col-md-3">
                                                    <div>
                                                        <label className=' text-nowrap'>Bulk Download</label>
                                                    </div>
                                                    <SubmitButton onClick={(e)=>{ 
                                                        setLoadingFilter("3"); 
                                                        downloadButton(); }}
                                                    // disabled={!filter?.location_id && !filter?.month && !filter?.department_id} 
                                                    buttonName={'Download'} icon={'ri-download-2-fill'} 
                                                    type='primary' iconSide='left' />
                                                </div>
                                            ) }
                                            
                                            {/* <div className="col-md-3">
                                                <div>
                                                    <label className=' text-nowrap'>Payslips</label>
                                                </div>
                                                <SubmitButton onClick={(e)=>{ 
                                                        setLoadingRows(true);
                                                        setPayslipType(!payslipType);
                                                        setIsChanged(true);
                                                  }}
                                                    loading={loadingRows} loadingMessage={"Loading"} 
                                                    disabled={loadingFilter || loadingRows || loadingDownload} 
                                                    buttonName={payslipType ? 'New Payslips':'Old Payslips'} 
                                                    icon={'ri-switch-line'} 
                                                    type='info' iconSide='left' />
                                            </div> */}
                                        </div>
                                    </div>

                                    <div id="example_wrapper" className="dataTables_wrapper dt-bootstrap5 no-footer">
                                        </div>
                                        <div className="row">
                                            <div style={{ "maxHeight": "65vh", "overflowY": "auto" }} className="col-sm-12">
                                                <table id="example" className="table table-bordered dt-responsive nowrap table-striped align-middle dataTable no-footer dtr-inline collapsed" style={{ width: '100%' }} aria-describedby="example_info">
                                                    <thead className="bg-primary text-light bg-gradient sticky-top z-1">
                                                        <tr>
                                                            {rows?.length > 0 && decodedData?.includes(3)  ?
                                                                <th>
                                                                    <div className="d-flex gap-1 align-items-center justify-content-center">
                                                                        
                                                                        <input
                                                                            type="checkbox"
                                                                            className="form-check-input"
                                                                            disabled={loadingDownload}
                                                                            checked={selectedRows.length === rows.length}
                                                                            onChange={handleSelectAll}
                                                                        />
                                                                            Select{" "}
                                                                        {selectedRows?.length > 0 && ( <span className="text-white">({selectedRows?.length})
                                                                        </span>
                                                                        )}
                                                                        
                                                                    </div>
                                                                </th> : null
                                                            }
                                                            <th className='noWrap'>Employee Code</th>
                                                            <th className='noWrap'>Employee Name</th>
                                                            <th>Designation</th>
                                                            <th>Department</th>
                                                            <th>Location</th>
                                                            {decodedData?.includes(3) && (
                                                                <th className=' text-center'>Action</th>
                                                            )}
                                                            
                                                        </tr>
                                                    </thead>
                                                    {rows?.length === 0 ?
                                                        <tbody>
                                                            <td colSpan={5}>
                                                                <NoRecords />
                                                            </td>
                                                        </tbody> :
                                                        <tbody>
                                                            {rows?.map((row, idx) => (
                                                                <tr key={row.employee_id}>
                                                                    { decodedData?.includes(3) && ( 
                                                                    <td>
                                                                        <div className="d-flex justify-content-center align-items-center">
                                                                            <input
                                                                                type="checkbox"
                                                                                className="form-check-input"
                                                                                disabled={loadingDownload}
                                                                                checked={selectedRows.some(val => val.employee_id === row?.employee_id)}
                                                                                onChange={() => handleCheckboxChange(row)}
                                                                            />
                                                                        </div>
                                                                    </td>)}
                                                                    <td>{row.employee_code}</td>
                                                                    <td>{row.employee_name}</td>
                                                                    <td>{row.designation_title}</td>
                                                                    <td>{row.department_title}</td>
                                                                    <td>{row.location_title}</td>
                                                                    {decodedData?.includes(3) && (
                                                                    <td className=' text-center'> 
                                                                        <SubmitButton onClick={(e)=>{ 
                                                                            setLoadingDownload(row?.employee_id);
                                                                                downloadButton(row);
                                                                            }}
                                                                            disabled={loadingDownload || selectedRows?.length>0}
                                                                            loading={loadingDownload==row?.employee_id} 
                                                                            loadingMessage={"Loading"}  buttonName={'Download'} icon={'ri-download-2-fill'} 
                                                                            type='primary' iconSide='left' />
                                                                    </td>)}
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    }

                                                </table>
                                            </div>
                                            <div className="d-flex bg-light justify-content-between align-items-center w-100 py-2 px-2" >
                                            <button disabled={!pagination?.prev} type="button" onClick={() => handlePrev()} className={`btn btn-warning btn-label waves-effect waves-light`}><i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" /> Previous</button>
                                            <div className='col-md-4' style={{ display: 'flex', alignItems: 'center' }}>
                                                {
                                                    <small>Total Records: {pagination?.total_records} | Total Pages: {pagination?.total_pages} | Current Page: {pagination?.page}</small>
                                                }
                                            </div>
                                            <div className='col-md-2'>
                                                <select className="form-select" onChange={(e) => handleChanged(e)}>
                                                    {Array.from({ length: pagination?.total_pages }, (_, i) => (
                                                        <option selected={pagination?.page === i + 1} key={i} value={i + 1}>Page {i + 1}</option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="col-md-2">
                                                <select className="form-select" onChange={(e) => handleLimitChange(e)} value={pagination?.limit}>
                                                    {/* {pagination?.total_records >= 1 && (
                                                        <option value={pagination?.total_records}>
                                                            All
                                                        </option>
                                                    )} */}
                                                    {limitOptions.map((option) => (
                                                        <option key={option} value={option}>
                                                            Limit {option}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <button disabled={!pagination?.next} type="button" onClick={() => handleNext()} className={`btn btn-primary btn-label waves-effect right waves-light`}><i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" /> Next</button>
                                        </div>
                                        </div>
                                    </div>
                                    {loadingFilter==="3" && (
                                        <div
                                        id="myModal"
                                        className="modal show"
                                        tabIndex={-1}
                                        style={{
                                            display: "block",
                                            backgroundColor: "rgba(0, 0, 0, 0.5)",
                                        }}
                                        aria-labelledby="myModalLabel"
                                        aria-hidden="true"
                                        >
                                        <div
                                            className=" h-100 d-flex justify-content-center align-items-center mt-3"
                                            style={{ width: "100%" }}
                                        >
                                            <div className="modal-content" style={{ width: "50%" }}>
                                            <div className="modal-body">
                                                <div className="card-body">
                                                <h3 className={` ${uploadProgress >= 100 ? "text-primary":"text-dark" } `}> {uploadProgress >= 100 ? "Payslips Downloaded Successfully":"Downloading Payslips"}</h3>
                                                <h5 className=" mb-4">
                                                    {uploadProgress < 100 ? (
                                                    <span className="d-flex align-items-center">
                                                        <span
                                                        class="spinner-border flex-shrink-0"
                                                        role="status"
                                                        style={{
                                                            width: "1.2rem",
                                                            height: "1.2rem",
                                                            borderWidth: "2px",
                                                        }}
                                                        >
                                                        <span className="visually-hidden">
                                                            Loading...
                                                        </span>
                                                        </span>
                                                        <span className="flex-grow-1 ms-2">
                                                        {uploadProgress > 85
                                                            ? "Almost Completed..."
                                                            : loadingRows==="1"? "Preparing Data..." : "Processing..."}
                                                        </span>
                                                    </span>
                                                    ) : (
                                                    "Completed"
                                                    )}
                                                </h5>
                                                <div className="progress animated-progress custom-progress progress-label mt-3">
                                                    <div
                                                    className="progress-bar bg-success"
                                                    role="progressbar"
                                                    style={{ width: `${uploadProgress}%` }}
                                                    aria-valuenow={uploadProgress}
                                                    aria-valuemin={0}
                                                    aria-valuemax={100}
                                                    >
                                                    <div className="label">{uploadProgress}%</div>
                                                    </div>
                                                </div>
                                                {uploadProgress >= 100 &&
                                                    (<div className=' d-flex justify-content-end align-items-center mt-3'>
                                                    <SubmitButton onClick={(e)=>{ 
                                                        setLoadingRows(false);
                                                        setLoadingDownload(false);
                                                        setLoadingFilter(false);
                                                        setDownload(false);
                                                        setUploadProgress(0);
                                                        setSelectedRows([]); }}
                                                    // disabled={!filter?.location_id && !filter?.month && !filter?.department_id} 
                                                    disabled={uploadProgress < 100} buttonName={'Close'} icon={'ri-close-line'} 
                                                    type='light' iconSide='left' />
                                                    </div>)}
                                                
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                    </div>
                                    )}
                                </div>
                            </div>
                        </div >


                    </div> :
                <div className='d-flex justify-content-center align-items-center' style={{ height: "90vh" }}>
                    <div className="text-center">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>

            }
        </>
    );
}

export default PaySlips;